import { connect } from 'react-redux'
import { doSetLeftSidebarOpenState, doToggleLeftSidebar } from 'actions/app'
import { doShowHotkeysModal } from 'ducks/modals/hotkeys'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors/base'
import { selectIsLeftSidebarCollapsed } from 'selectors/app'
import { selectIsInInbox } from 'selectors/location'
import {
  selectMenuNoticeCounts,
  selectMenuAlerts,
  selectSettingsLandingPageAction,
} from 'selectors/menus'
import { selectAccountPreferenceChatEnabled } from 'selectors/app/selectAccountPreferences'

import View from './view'

const select = state => ({
  isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
  isInInbox: selectIsInInbox(state),
  noticeCounts: selectMenuNoticeCounts(state),
  alerts: selectMenuAlerts(state),
  currentUserIsAdminOrOwner: selectCurrentUserIsAdminOrOwner(state),
  isChatEnabled: selectAccountPreferenceChatEnabled(state),
  settingsLandingPageAction: selectSettingsLandingPageAction(state),
})

const perform = {
  setLeftSidebarOpenState: doSetLeftSidebarOpenState,
  showHotkeysModal: doShowHotkeysModal,
  toggleLeftSidebar: doToggleLeftSidebar,
}

export default connect(select, perform)(View)
